import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkPermission, Constants } from 'utils';

const Reports = () => {
	if (checkPermission(Constants.MODULES.VERIFICATION_PLANS,'read'))
		return <Redirect to="/admin/plans/verifications" />
	if (checkPermission(Constants.MODULES.DOCUMENT_PLANS,'read'))
		return <Redirect to="/admin/plans/documents" />
	if (checkPermission(Constants.MODULES.BILL_PLANS,'read'))
		return <Redirect to="/admin/plans/bills" />
}

export default Reports;